import type { Moment, unitOfTime } from 'moment';

import { formatStartOf } from '@helpers';
import type { StatisticsPeriodsDto } from '@api/domain/types';
import { TimePeriod } from '@v2/pages/machines/common/enums';
import { DATE_FORMAT } from '@v2/pages/common/constants/base.constants';

// TimePeriod → moment unit + per-page step count. 'eightWeeks' = 8 ISO weeks/page.
export const getPeriodStep = (selectedTime) => {
  if (selectedTime === TimePeriod.EIGHT_WEEKS) return { unit: 'isoWeek', count: 8 };
  return { unit: formatStartOf(selectedTime as unitOfTime.StartOf), count: 1 };
};

// 8-week window ending with `anchor`'s ISO week (anchor = LAST bar). Returns
// inclusive `start` (Monday of first bar) and exclusive `end` (Monday after last bar).
export const getEightWeeksWindow = (anchor: Moment): { start: Moment; end: Moment } => {
  const end = anchor.clone().add(1, 'isoWeek').startOf('isoWeek');
  const start = end.clone().subtract(8, 'isoWeek');
  return { start, end };
};

// Builds params for statistics POST. 'eightWeeks' is FE-only; the backend uses the
// dedicated MultipleWeeks period and the first day of the requested window.
export const getStatsRequestParams = (selectedTime, momentStart: Moment) => {
  if (selectedTime === TimePeriod.EIGHT_WEEKS) {
    return {
      period: 'MultipleWeeks' as StatisticsPeriodsDto,
      date: getEightWeeksWindow(momentStart).start.format(DATE_FORMAT),
      numberOfWeeks: 8,
    };
  }
  return {
    period: selectedTime,
    date: momentStart.clone().startOf(formatStartOf(selectedTime as unitOfTime.StartOf)).format(DATE_FORMAT),
  };
};
